/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import moment from "moment";
import ScheduleEntryRow from "./ScheduleEntryRow";

function ScheduleEntryList({ entries, setEntries, isEditMode, readOnly, onEntryRemove }) {
  const hasImmediateEntry = entries.some(
    (e) => e.notification_send_type === "1" || e.notification_send_type === 1
  );

  const handleUpdate = (index, updatedEntry) => {
    if (readOnly) return;
    const newEntries = [...entries];
    newEntries[index] = updatedEntry;
    setEntries(newEntries);
  };

  const handleRemove = (index) => {
    if (readOnly || entries.length <= 1) return;
    const removed = entries[index];
    if (onEntryRemove && (removed.n_id || removed.p_id)) {
      onEntryRemove(removed.n_id || removed.p_id);
    }
    setEntries(entries.filter((_, i) => i !== index));
  };

  const handleAdd = () => {
    if (readOnly) return;
    setEntries([
      ...entries,
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
      }
    ]);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Schedule Dates
      </Typography>
      {entries.map((entry, index) => (
        <ScheduleEntryRow
          key={entry._uid || entry.n_id || index}
          entry={entry}
          index={index}
          totalEntries={entries.length}
          hasImmediateEntry={hasImmediateEntry}
          onUpdate={handleUpdate}
          onRemove={handleRemove}
          isEditMode={isEditMode}
          readOnly={readOnly}
        />
      ))}
      {!readOnly && (
        <Button
          startIcon={<Add />}
          variant="outlined"
          onClick={handleAdd}
          sx={{ mt: 1, textTransform: "none" }}
        >
          Add Schedule Date
        </Button>
      )}
    </Box>
  );
}

export default ScheduleEntryList;
